import ApiClient from 'lib/SanityClient/ApiClient';

import validateSchema from 'utils/validateSchema';
import { QuizQueryParamsSchema } from './schemas';
import type { QuizQueryParams } from './schemas';
import type { QuizType, PageHero } from 'types';
import sanitizeImage from 'state/sanitizers/sanitizeImage';
import { EmphasizeModuleColor } from 'constants/ColorScheme';
import { Language } from 'hooks/useLanguage';

export function validateQueryParams(query: unknown) {
  const queryParams: QuizQueryParams = validateSchema({
    schema: QuizQueryParamsSchema,
    data: query,
    shouldLog: false,
  });
  return queryParams;
}

type FetchQuizzesOptions = {
  type: QuizType;
  limit: number;
  pageNumber: number;
  titleStartsWith?: string;
};
export async function fetchQuizzes(options: FetchQuizzesOptions) {
  const result = await ApiClient.fetchQuizzes(options);
  return result;
}

// Bit of a hack so we can use the PageHero module without sanity
export function generatePageHero({
  title,
  description,
  image,
  color,
}: {
  title: string;
  description: string;
  image: { _id: string; url: string };
  color: EmphasizeModuleColor;
}) {
  const fakeHero = {
    variant: 'general-md',
    color,
    buttonLink: '',
    buttonLabel: '',
    buttonVariant: '',
    modules: [],
    mobileImage: sanitizeImage(image),
    desktopImage: sanitizeImage(image),
    desktopImageWidth: 243,
    title,
    description,
  } as unknown as PageHero;
  return fakeHero;
}

export const dxQuizPageHero = (language: Language) =>
  generatePageHero({
    title: language.t('Quiz.dxBrowse.heroTitle'),
    description: language.t('Quiz.dxBrowse.heroDescription'),
    color: 'LIGHTEST_ORANGE',
    image: {
      _id: 'image-4af066ac3c77f4a44d67201469567eb390dd75c9-902x1061-svg',
      url: 'https://cdn.sanity.io/images/0b678gck/buoy-public-site/4af066ac3c77f4a44d67201469567eb390dd75c9-902x1061.svg',
    },
  });

export const sxQuizPageHero = (language: Language) =>
  generatePageHero({
    title: language.t('Quiz.sxBrowse.heroTitle'),
    description: language.t('Quiz.sxBrowse.heroDescription'),
    color: 'LIGHTEST_GREEN',
    image: {
      _id: 'image-188936158aae02f68a2ddbd8fffb3096d13f4ead-400x400-svg',
      url: 'https://cdn.sanity.io/images/0b678gck/buoy-public-site/188936158aae02f68a2ddbd8fffb3096d13f4ead-400x400.svg',
    },
  });
